import React from 'react';
import cn from 'classnames';
import cls from './RequestMaterialGroup.module.css';
import { useTranslation } from 'react-i18next';
import { IRequestMaterialGroupPosition } from '@entities/requestMaterial';
import { UiText } from '@shared/ui';
import { RequestMaterialPosition } from '@entities/requestMaterial/ui/RequestMaterialPosition';

interface RequestMaterialGroupProps {
    classes?: string;
    group: IRequestMaterialGroupPosition;
}

export const RequestMaterialGroup = ({ classes, group }: RequestMaterialGroupProps) => {
    return (
        <div className={cn(cls.RequestMaterialGroup, [classes])}>
            <div className={cls.groupTitle}>
                <UiText variant={'subPlain'} weight={'bold'}>
                    {group.name}
                </UiText>
            </div>
            {group.children.map((position) => (
                <RequestMaterialPosition key={position.guid} position={position} />
            ))}
        </div>
    );
};
